import React, { useRef, useState } from 'react';
import useClickOutside from '../../../../common/hooks/useClickOutside';

import { Popup } from '@progress/kendo-react-popup';
import Icon from '../../icon/icon';

import { NotesPopupProps } from './notesPopupProps';

import './notesPopup.scss';
import getUID from '../../../../common/utility/getUID';

const NotesPopup: React.FC<NotesPopupProps> = ({ notes }) => {
  const [notesShown, setNotesShown] = useState<boolean>(false);
  const [position, setPosition] = useState<any>({ left: 0, top: 0 });

  const wrapperRef = useRef<any>(null);

  const toggleNotes = (e): void => {
    setPosition({ left: e.pageX + 19, top: e.pageY + 19 });
    setNotesShown(!notesShown);
  };

  const clickOutsideHandler = () => {
    setNotesShown(false);
  };

  const randomId = getUID();

  useClickOutside(wrapperRef, clickOutsideHandler, 'notes-icon');

  return (
    <div className="notes-wrapper">
      <Icon name={`${notesShown ? 'far' : 'fas'} fa-circle-info`} className="notes-info pointer" onClick={toggleNotes} id={'notes-icon' + randomId} />
      {notesShown && (
        <div ref={wrapperRef}>
          <Popup offset={position} show={notesShown} popupClass={'notes-popup-content'} className={'notes-content'} animate={false}>
            {notes.map((note, key) => (
              <p key={key}>
                {note.symbol} {note.note}
              </p>
            ))}
          </Popup>
        </div>
      )}
    </div>
  );
};

export default NotesPopup;
